/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 批量编辑水印-添加照片弹窗
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-02-09 10:10:00
 */

import React from 'react'
import { Modal } from 'antd'
import { AddBatchEditPhotos } from '../../addPhotos'
import type { PhotoItem } from '../context/WatermarkBatchContext'
import './AddPhotosModal.scss'

interface AddPhotosModalProps {
  visible: boolean
  currentPhoto?: PhotoItem | null
  onClose: () => void
}

const AddPhotosModal: React.FC<AddPhotosModalProps> = ({
  visible,
  currentPhoto,
  onClose
}) => {
  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      mask={{ closable: false }}
      keyboard={false}
      destroyOnHidden={true}
      wrapClassName="add-batch-photos-modal"
      zIndex={1100}
      width="92vw"
      style={{ top: 24, maxWidth: 1280, paddingBottom: 0 }}
      styles={{
        content: {
          height: 'calc(100vh - 48px)',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 12,
          overflow: 'hidden',
          padding: 0
        },
        body: {
          flex: 1,
          padding: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0
        }
      }}
    >
      <AddBatchEditPhotos
        inModal={true}
        onClose={onClose}
        currentPhoto={currentPhoto}
      />
    </Modal>
  )
}

export default AddPhotosModal
